<div class="analysis-dashboard" [class.active]="state().is_processing">
    <!-- 1. COLA -->
    <div class="section queue-section">
        <div class="queue-badge" [class.processing]="state().is_processing">
            <mat-icon>{{ state().is_processing ? 'sync' : 'pause_circle_outline' }}</mat-icon>
            <span>{{ state().is_processing ? 'Procesando' : 'Inactivo' }}</span>
        </div>
        <div class="queue-counter">
            <span class="number">{{ state().queue_length }}</span>
            <span class="label">en espera</span>
        </div>

        <!-- CONTROLES DE COLA -->
        <div class="queue-controls" *ngIf="state().queue_length > 0 || state().is_processing">

            <button mat-icon-button color="warn" *ngIf="state().is_processing" (click)="pause()" matTooltip="Pausar">
                <mat-icon>pause</mat-icon>
            </button>

            <button mat-icon-button color="primary" *ngIf="!state().is_processing && state().queue_length > 0"
                (click)="resume()" matTooltip="Reanudar">
                <mat-icon>play_arrow</mat-icon>
            </button>

            <button mat-icon-button color="accent" (click)="purge()" matTooltip="Vaciar">
                <mat-icon>delete_sweep</mat-icon>
            </button>
        </div>
    </div>

    <!-- 2. MONITOR ACTIVO -->
    <div class="section active-section">
        @if (state().current_job; as job) {
        <div class="job-details">
            <div class="job-header">
                <!-- MOSTRAR FOLIO EN LUGAR DE ID -->
                <span class="job-id">{{ job.document_folio || job.document_id | slice:0:12 }}</span>
                <span class="timer">{{ formatTime(elapsedTime()) }}</span>
            </div>

            <mat-progress-bar mode="indeterminate" class="job-progress"></mat-progress-bar>

            <!-- Mostrar qué intento está corriendo -->
            <div class="step-info">
                <span class="step-label">{{ job.step }}</span>
                @if (job.attempts && job.attempts.length > 0) {
                <span class="attempt-badge">Intento {{ job.attempts.length }}</span>
                }
            </div>

            <button mat-button class="details-btn" (click)="openDetails(job)">
                Ver Detalles en Vivo
            </button>
        </div>
        } @else {
        <div class="idle-state">
            <mat-icon>hourglass_empty</mat-icon>
            <span>Esperando documentos...</span>
        </div>
        }
    </div>

    <!-- 3. HISTORIAL -->
    <div class="section history-section">
        <div class="history-list">
            @for (job of state().history.slice(0, 3); track job.document_id) {
            <div class="history-item" [ngClass]="job.status.toLowerCase()" (click)="openDetails(job)">
                <mat-icon class="status-icon">
                    {{ job.status === 'COMPLETADO' ? 'check_circle' : (job.status === 'ERROR' ? 'error' : 'warning') }}
                </mat-icon>
                <div class="history-info">
                    <span class="id">{{ job.document_folio || (job.document_id | slice:0:6) }}</span>
                    <span class="time">{{ job.duration_seconds }}s</span>
                </div>
            </div>
            }
        </div>
    </div>
</div>